import { render } from "./Login.vue?vue&type=template&id=36e2a07f&scoped=true&ts=true"
import script from "./Login.vue?vue&type=script&lang=ts"
export * from "./Login.vue?vue&type=script&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=36e2a07f&lang=scss&scoped=true"

import exportComponent from "/src/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36e2a07f"]])

export default __exports__